export const STALE = {
  /** 1 minute — for rapidly updating data (analytics live, streaming) */
  ONE_MIN: 60 * 1000,
  /** 5 minutes — the default for most queries */
  FIVE_MIN: 5 * 60 * 1000,
  /** 10 minutes — for reference data that changes infrequently */
  TEN_MIN: 10 * 60 * 1000,
  /** 30 minutes — for almost-static data (facilities, categories, BUs) */
  THIRTY_MIN: 30 * 60 * 1000,
} as const;

/**
 * Central registry for query keys shared across files.
 * Feature hooks still define their own local keys; these are the
 * cross-cutting roots that must stay in sync between producers and
 * invalidators.
 */
export const QUERY_KEYS = {
  account: {
    sessions: ["account", "sessions"] as const,
  },
  businessUnits: ["business-units"] as const,
  subscription: {
    plans: ["subscription", "plans"] as const,
  },
} as const;
